import styled, { css } from 'styled-components';

import { colors } from '../../styles/constants';
import { FormBuilderWrapperStyled } from './FormBuilder.types';

export const FormBuilderWrapper = styled.form<FormBuilderWrapperStyled>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 100%;
  ${({ maxWidth }) =>
    maxWidth
      ? css`
          max-width: ${maxWidth}px;
        `
      : ''}

  ${({ borderRadius }) =>
    borderRadius
      ? css`
          border-radius: ${borderRadius}px;
        `
      : ''}

  ${({ enableShadow }) =>
    enableShadow
      ? css`
          box-shadow: 0 4px 17px -3px rgba(43, 43, 43, 0.15);
        `
      : ''}

  ${({ backgroundColor }) =>
    backgroundColor
      ? css`
          background-color: ${backgroundColor};
        `
      : ''}

  ${({ horizontalPaddingMobile }) =>
    horizontalPaddingMobile
      ? css`
          padding-inline: ${horizontalPaddingMobile};
        `
      : ''}

  ${({ verticalPaddingMobile }) =>
    verticalPaddingMobile
      ? css`
          padding-block: ${verticalPaddingMobile};
        `
      : ''}

  ${({ theme }) => theme.mediaQuery.md} {
    ${({ horizontalPadding }) =>
      horizontalPadding
        ? css`
            padding-inline: ${horizontalPadding};
          `
        : ''}

    ${({ verticalPadding }) =>
      verticalPadding
        ? css`
            padding-block: ${verticalPadding};
          `
        : ''}
  }
`;

export const FormBuilderFormErrorMessage = styled.div`
  margin-top: 24px;
  font-size: 16px;
  font-family: Roboto, sans-serif;
  color: ${colors.red};
`;

export const FormBuilderFormSuccessMessage = styled.div`
  margin-top: 24px;
  font-size: 16px;
  font-family: Roboto, sans-serif;
  color: ${colors.darkGreen};
`;
